import React, { useEffect } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';

import { LDClientRef, LDConfig } from './LaunchDarkly.types';

export const LD_CLIENT: LDClientRef = { instance: null };

export function getFlags() {
  return LD_CLIENT.instance?.allFlags() || {};
}

export function initialize({
  launchDarklyToken,
  appName = 'unknown',
  version = '1',
  logger,
}: LDConfig = {}) {
  if (LD_CLIENT.instance) return LD_CLIENT.instance;
  if (logger) LD_CLIENT.logger = logger;
  if (!launchDarklyToken) {
    LD_CLIENT.logger?.error('LaunchDarkly Token is missing', 'LaunchDarkly');
    return LD_CLIENT.instance;
  }

  const id = window.location.host?.split('.').reverse().join('.');
  const context: { [key: string]: string } = {
    envAttributesVersion: '1.0',
    id,
    key: btoa(JSON.stringify({ id, version })),
    kind: 'ld_application',
    locale: 'es_MX',
    name: appName,
    version: '1',
    versionName: version,
  };

  LD_CLIENT.instance = LDClient.initialize(launchDarklyToken, context);

  return LD_CLIENT.instance;
}

export async function identify(user: string, data: { [key: string]: string } = {}) {
  if (!LD_CLIENT.instance) {
    LD_CLIENT.logger?.error('LaunchDarkly is not initialized', 'LaunchDarkly');
    return Promise.reject(new Error('LaunchDarkly is not initialized'));
  }
  const { key: storedUserId } = LD_CLIENT.instance.getContext();
  const userId = user || storedUserId;
  const context = {
    key: String(userId),
    kind: 'user',
    ...data,
  };

  return LD_CLIENT.instance.identify(context);
}

export function withLDProvider<T extends object>(config: LDConfig) {
  return (Component: React.ComponentType<T>) => {
    const ComponentWithOnMount: React.ComponentType<T> = props => {
      useEffect(() => {
        initialize(config);
      }, []);

      return <Component {...props} />;
    };
    return ComponentWithOnMount;
  };
}
